module.exports = __webpack_public_path__ + "img/mock_bcg.9c68e76d.png";